module.exports = __webpack_public_path__ + "img/move.60a902ee.png";